import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";
import TangentRatioButton from "../entities/TangentRatioButton";


export default class TangentRatioButtonManager {
  private triangle: TangentRatioButton[] = Array(3).fill(null)
    .map((_, index) => new TangentRatioButton(index));

  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }

  setAllVisible = (status: boolean) => this.triangle.forEach(b =>  b.visible = status);
  draw(coords: Coord[], sltdTPIndex: number) {
    this.triangle.forEach((button, bI) => button.draw(coords[bI], bI == sltdTPIndex));
  }
}